import React from "react";
import { Link } from "react-router-dom";
import ModuleHeader from "../modules/ModuleHeader";
import { useSelector } from "react-redux";
import { selectModulesWithTopicsAndActivities } from "../../store/selectors";
import { useClearCurrentTopic } from "../../hooks/useClearCurrentTopic";
import { logEvent, logInteractionEvent } from "../../utils/appInsight";
import { useTranslation } from "react-i18next";
import { trackAdobeClick } from "../../utils/adobeLogging";

const ToolsAndTemplates = () => {
  useClearCurrentTopic();
  const sections = useSelector((state) =>
    selectModulesWithTopicsAndActivities(state)
  );
  const pmApproach = useSelector((state) => state.progress.section);
  const lang = useSelector((state) => state.ui.lang);
  const { t } = useTranslation();

  const links = (topic) => {
    const result = [];

    if (topic.data.activity.hasActivity) {
      result.push(
        <Link
          to={`/app/activity/${topic.data.activity.activityKey}`}
          className="cursor-pointer text-indigo-800 text-sm"
        >
          {t("Activity")}
        </Link>
      );
    }

    if (topic.data.template.hasTemplate) {
      result.push(
        <a
          onClick={() => {
            logEvent({
              name: "TemplateDownloaded",
              properties: {
                section: pmApproach,
                template: topic.data.template,
              },
            });
            logInteractionEvent("TemplateDownloaded", {
              section: pmApproach,
              template: topic.data.template.fileUrl,
            });
          }}
          href={topic.data.template.fileUrl}
          download={topic.data.template.fileUrl}
          className="cursor-pointer text-indigo-800 text-sm"
        >
          {t("download")} {topic.data.template.title}
        </a>
      );
    }

    if (result.length > 1) {
      return [result[0], <span>|</span>, result[1]];
    }

    return result;
  };

  console.log(sections);

  return (
    <div adoberegion={`${pmApproach}-tools-and-templates`}>
      <ModuleHeader title={t("projectToolsAndTemplates")} />

      <div className="lg:px-0 px-3">
        <div className="bg-white shadow rounded py-10 mt-5">
          <div>
            <div className="pb-5 px-24">
              <p>{t("toolsAndTemplatesTagline")}</p>
            </div>

            {sections.map((section, index) => (
              <div
                key={section.id}
                className={`
                    py-8 px-24
                    ${index % 2 === 0 && "bg-gray-200"} 
                  `}
              >
                <h2
                  className={`uppercase text-${section.data.accentColor} text-2xl font-bold leading-sm`}
                >
                  {section.data.title || section.title}
                </h2>

                {section.topics.map((topic) => (
                  <div key={topic.id} className={"mt-5"}>
                    <Link to={`/app/${section.contentKey}/${topic.contentKey}`} className={`text-black font-bold cursor-pointer`}>
                      {topic.data.title ||
                        topic.title}
                    </Link>

                    <div className={"mt-3 flex space-x-2"}>
                      {links(topic).map((item, index) => (
                        <div key={index}>{item}</div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ToolsAndTemplates;
